export const languageLevels = [
    'Beginner',
    'Intermediate',
    'Proficient',
    'Native',
];
